module.exports = __webpack_public_path__ + "img/04.ba3a2d4a.png";